module.exports = __webpack_public_path__ + "static/media/Selfie-T-02.0662893d.png";